import React from 'react';
import BitBackground from '../BitBackground';
import Apollo from '../Apollo';
import styles from './AwardBlock.css';
import Svg from '../InlineSVG';
import { WinnerBadge } from './';
import { gcpURL } from '../../lib/utils';

const iconLogo = `${gcpURL}/static/ig-logo-gloden-feather.svg`;
const iconTrophy = `${gcpURL}/static/ic-trophy@2x.png`;

const SimpleAwardBlock = ({
  awardTitle,
  info,
  hasWinner,
  winnerPic,
  winner,
  nominee,
  isNoWrap,
  isLong,
  className,
  children,
}) => (
  <div
    className={`${
      isLong ? styles.awardLong : styles.awardBlock
    } ${
      hasWinner ? styles.hasWinner : ''
    } ${
      className || ''
    }`}
    onClick={ () => {} }
  >
    <div className={styles.cover}>
      {(hasWinner && winnerPic) ? (
        <Apollo className={styles.winnerCover} style={{ backgroundImage: `url(${winnerPic})` }} />
      ) : null}
      <BitBackground className={styles.bitBackground} isLighter={hasWinner} />
      <div className={styles.awardTitle}>
        <img src={iconTrophy} className={styles.iconTrophy} alt="trophy" />
        <img src={iconLogo} alt={awardTitle} />
        <span className={`${styles.title} ${isNoWrap ? styles.noWrap : ''}`}>
          {awardTitle.split(' ').map((item, index) => <div key={index}>{item}</div>)}
        </span>
      </div>
    </div>

    {winnerPic ? (
      <div className={styles.mobileWinnerPic}>
        <img src={winnerPic} alt={winner} />
      </div>
    ) : null}

    {(hasWinner && winner) ? (
      <WinnerBadge winner={winner} />
    ) : null}

    {(info || nominee) ? (
      <div className={styles.longCover}>
        {info ? (
          <div className={styles.infoBlock}>
            <div className={styles.infoLabel}>獎項<br />介紹</div>
            <p className={styles.info}>{info}</p>
          </div>
        ) : null}

        {nominee ? (
          <div className={styles.nomineeBlock}>
            <div className={styles.infoLabel}>入圍<br />名單</div>
            <div className={styles.info}>
            { nominee.split(',').map((item, index) => (<div key={index}>{item}</div>) ) }
            </div>
          </div>
        ) : null}
      </div>
    ) : null}


    {children || null}
  </div>
);

export default SimpleAwardBlock;



// WEBPACK FOOTER //
// ./src/components/AwardBlock/SimpleAwardBlock.js